<template>
  <Modal :id="'cmp-add-comment'" @cancelled="onCancelClick">
    <template slot="header">Add {{$t(title)}}</template>
    <template slot="body">
      <div class="form-group">
        <TextField
          class="m1"
          :id="'private_comments'"
          v-bind="textAreaConfig"
          v-model="commentString"
          isModel
          :placeholder="$t(title)"
        />
      </div>
    </template>
    <template slot="options">
      <button class="dt-button s6" @click="onCancelClick">Cancel</button>
      <button class="dt-button v1 s6" @click="onOKClick">OK</button>
    </template>
  </Modal>
</template>

<script>
import Modal from "../modal/modal";

import { CommentService } from "./comment.service";

import { createComment } from "./comment.model";
import { allValidString } from "../../utility";
import { NotificationService } from "../notification/notification.service";

import { getCommentConfig } from "./comment.config";

import { pickAll } from 'ramda';

export default {
  components: {
    Modal
  },
  props: {
    comment: {
      type: Object,
      default: () => createComment()
    }
  },
  data: function() {
    return {
      textAreaConfig: {
        height: 120,
        showEditIconOnHover: false,
        box: true,
        textarea: true,
        showValidationIcons: false
      },
      commentString: "",
      config: ""
    };
  },
  mounted: function() {
    console.log(this.reqObject);
    console.log();
    const result = allValidString(
      pickAll(["section", "table_id", "status"])(this.reqObject)
    );

    if (!result.valid) {
      NotificationService.showNotification({
        text: `${result.invalid.join(", ")} - not valid`,
        timeout: 3000
      }).then(res => {
        this.$emit("cancelled", true);
      });
    }

    this.config = getCommentConfig(this.section);
  },
  computed: {
    title: function() {
      if (this.status === "private") {
        return "private_comments";
      } else if (this.status === "public") {
        return "public_comments";
      }
    },

    status: function() {
      return this.$route.query.status;
    },
    id: function() {
      return this.$route.query.id;
    },
    section: function() {
      return this.$route.query.section;
    },
    reqObject: function() {
      return {
        section: this.section,
        table_id: this.id,
        status: this.status,
        comment: this.commentString
      };
    }
  },
  methods: {
    onCancelClick: function() {
      this.$emit("cancelled", true);
    },
    onOKClick: function() {
      CommentService.insertComment({
        ...this.reqObject,
        comment: this.commentString
      }).then(res => {
        this.$emit("done", {
          action: this.config.action,
          data: res.data
        });
      });
    }
  }
};
</script>

<style lang="scss" scoped>
</style>